import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { compose, withProps } from 'react-recompose';
import { CommonActions } from '@react-navigation/native';
import Navigation from '../../lib/navigation';
import BillingAddress from '../SignUp/Address/BillingAddress.container';
import { billingAddressSelector, customerFullNameSelector } from '../../modules/Customer/selectors';
import { updateBillingAddress } from '../../modules/BillingAddress/actions';
import validate from '../SignUp/Address/validation';

const getInitialValues = state => ({
  ...billingAddressSelector(state),
  fullName: customerFullNameSelector(state),
});

const mapStateToProps = state => ({
  initialValues: getInitialValues(state),
  postCode: formValueSelector('changeBillingAddress')(state, 'postCode'),
});

const mapDispatchToProps = dispatch => ({
  changeFormField: (fieldName: string, fieldValue: string) =>
    dispatch(change('changeBillingAddress', fieldName, fieldValue)),
  onSubmit: values => {
    dispatch(updateBillingAddress(values));
    Navigation.dispatch(CommonActions.goBack());
  },
});

const withFlaggedProps = (): { displayCheckboxUseSameAddresses: boolean } => ({
  displayCheckboxUseSameAddresses: false,
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(withFlaggedProps),
  reduxForm({ form: 'changeBillingAddress', validate })
);
export default enhance(BillingAddress);
